import React, { useState, useEffect } from 'react';

export default function EditModal({ item, onSave, onDelete, onCancel }) {
    const DEFAULT_VENUES = ['costco', 'meijer'];
    let [name, set_name] = useState(item.name);
    let [venue, set_venue] = useState(item.venue);

    const options = DEFAULT_VENUES.map(v =>
        <option key={v} value={v}>{v}</option>
    );

    const escFunction = function (event) {
        if (event.key === "Escape") {
            onCancel();
        }
    }

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);
        return () => {
            document.removeEventListener("keydown", escFunction, false);
        };
    });

    function handleNameChange(event) {
        set_name(event.target.value);
    }

    function handleVenueChange(event) {
        set_venue(event.target.value);
    }

    const saveDisabled = !name || name.trim().length === 0;

    const selectStyle = {
        width: "100%",
        textAlign: "center",
        backgroundColor: "#282c34",
        color: "white",
        fontSize: "inherit",
        padding: "4px",
    }

    return (
        <div className="App-body">

            <header className="App-vertical-body">
                <div>
                    <h2>Edit Sumthin</h2>
                </div>
                <table>
                    <tbody>
                    <tr>
                        <th>Name</th>
                        <td><input style={selectStyle} type="text" name="name" value={name}
                                   onChange={handleNameChange}/></td>
                    </tr>
                    <tr>
                        <th>Venue</th>
                        <td><select style={selectStyle} value={venue}
                                    onChange={handleVenueChange}>{options}</select></td>
                    </tr>
                    <tr>
                        <td colSpan='2'>
                            <button className='yellow_button' onClick={onCancel}>Cancel</button>
                            <button className='red_button'
                                    onClick={() => onDelete(item.name, item.venue)}>Delete
                            </button>
                            <button className='button-3' disabled={saveDisabled}
                                    onClick={() => onSave(item.name, item.venue, name, venue)}>Save
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </header>
        </div>
    );
}
